export var ViewTemplateType;
(function (ViewTemplateType) {
    ViewTemplateType[ViewTemplateType["Colorless"] = 1] = "Colorless";
    ViewTemplateType[ViewTemplateType["Fancy"] = 2] = "Fancy";
    ViewTemplateType[ViewTemplateType["Jewelry"] = 3] = "Jewelry";
    ViewTemplateType[ViewTemplateType["Rough"] = 4] = "Rough";
    ViewTemplateType[ViewTemplateType["Gem"] = 5] = "Gem";
})(ViewTemplateType || (ViewTemplateType = {}));
